import { Box, Card, Heading, Stack, Text } from '@chakra-ui/react';
import type { ComponentProps, FC } from 'react';

import { ContactSalesButton } from '../../../trialUser/ContactSalesButton';
import { CentrializedLayout } from './centralized-layout';

interface TrialPageContentProps {
  children?: React.ReactNode;
}

const SimpleCard: FC<ComponentProps<typeof Card>> = (props) => {
  return (
    <Card
      p={6}
      borderRadius="xl"
      backgroundColor="white"
      shadow="none"
      {...props}
    />
  );
};

export const TrailPageConent: FC<TrialPageContentProps> = ({ children }) => {
  return (
    <CentrializedLayout>
      <Stack spacing={6} mb={8}>
        <SimpleCard p={10}>{children}</SimpleCard>
        <SimpleCard px={10} pt={10} pb={7}>
          <Stack spacing={4}>
            <Box color="text.primary">
              <Heading as="h1" fontSize="4xl" fontWeight="semibold" mb={2}>
                Contact Sales To Unlock
              </Heading>
              <Text>Gain full access by contacting our sales team.</Text>
            </Box>
            <ContactSalesButton />
          </Stack>
        </SimpleCard>
      </Stack>
    </CentrializedLayout>
  );
};
